import { render, staticRenderFns } from "./AddressWarning.vue?vue&type=template&id=29ca46e8&scoped=true&"
import script from "./AddressWarning.vue?vue&type=script&lang=js&"
export * from "./AddressWarning.vue?vue&type=script&lang=js&"
import style0 from "./AddressWarning.vue?vue&type=style&index=0&id=29ca46e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ca46e8",
  null
  
)

export default component.exports